































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import { Settings, DateTime } from 'luxon'
import {
  beginningOfCurrentDay,
  currentDate,
  currentDateEnd,
  currentDay,
  maxOneMonth,
  minOneMonth
} from "@/utils/date-util";

@Component({components: {Datetime}})
export default class DatePickerWings extends Vue {
  @Prop() value!: string;
  @Prop() minDatetime!: string;
  @Prop({default: undefined}) maxDatetime!: string | undefined;
  @Prop({ default: true }) isSetMinDatetime!: boolean;
  @Prop({ default: 'datetime' }) readonly type!: string;
  @Prop({ default: () => {}}) readonly errorsList!: any;
  @Prop({ default: false }) readonly disableCloseButton!: boolean;
  @Prop({ default: null }) format!: string;
  @Prop({ default: undefined }) readonly interval!: 'oneMonthFrom' | 'oneMonthTo';
  @Prop({ default: false }) readonly clearableEmpty!: boolean;
  @Prop({ default: false }) readonly clearToEndDate!: boolean;

  created(){
    Settings.defaultLocale = this.$i18n.locale;
  }

  get minDate():string | undefined{
    if (this.interval === 'oneMonthFrom'){
      return minOneMonth(this.maxDatetime);
    }else if(this.interval === 'oneMonthTo'){
      return this.minDatetime;
    }else {
      return this.minDatetime;
    }
  }

  get maxDate(): string | undefined{
    if (this.interval === 'oneMonthFrom'){
      return this.maxDatetime;
    }else if(this.interval === 'oneMonthTo'){
      return maxOneMonth(this.minDatetime);
    }else {
      return this.maxDatetime;
    }
  }

  get valueSelf(): string{
    let min = this.minDatetime;
    if (min && this.isSetMinDatetime){
      let minDate = DateTime.fromISO(min).set({millisecond:0});
      let value = DateTime.fromISO(this.value).set({millisecond:0});
      if (value < minDate) {
        this.$emit('input',minDate.plus({hour:1}).toISO({
          includeOffset: false,
          suppressMilliseconds: true
        }))
      }
    }
    return this.value
  }

  set valueSelf(value: string) {
    if (this.type == 'datetime' && value){
      value = DateTime.fromISO(value).set({millisecond:0}).toISO({
        includeOffset: false,
        suppressMilliseconds: true
      }) ?? ''
    } else if (this.type == 'time' && value){
      value = DateTime.fromISO(value).set({millisecond:0}).toISOTime({
        includeOffset: false,
        suppressSeconds: true,
        suppressMilliseconds: true,
      }) ?? ''
    } else if (this.type == 'date' && value){
      if (this.format) value = DateTime.fromISO(value).toFormat(this.format) ?? ''
      else value = DateTime.fromISO(value).set({millisecond:0}).toFormat('yyyy-LL-dd') ?? ''
    }
    if (value){
      this.$emit('input',value)
    }
  }

  clearValue(): void{
    if (!this.clearableEmpty){
      if (!this.minDatetime){
        if (this.type == 'date') {
          this.$emit('input',currentDay());
        } else {
          this.$emit('input',beginningOfCurrentDay());
        }
      } else {
        if (this.type == 'date') {
          this.$emit('input',currentDay());
        } else {
          this.clearToEndDate
              ? this.$emit('input',currentDateEnd())
              : this.$emit('input',currentDate());
        }
      }
    } else{
      this.$emit('input', null);
      this.$emit('reset')
    }
  }
}
